import { Component, OnInit } from '@angular/core';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';

@Component({
  selector: 'hybse-admin-ibo-logs',
  templateUrl: './ibo-logs.component.html',
  styleUrls: ['./ibo-logs.component.css']
})
export class IboLogsComponent implements OnInit {
  public idUser: string;
  public iboSellOrder: any[];
  public iboBuyOrder: any[];
  public iboCommissionLog: any[];
  public buyOrderMessage: string;
  public sellOrderMessage: string;
  public commissionLogMessage: string;

  constructor(private _req: ApirequestService,
    private _url: ApiurlsService, ) {
    this.idUser = localStorage.getItem('idUser')
  }

  ngOnInit() {
    this.getIboBuyOrderList();
    this.getIboSellOrderList();
    this.getIboCommissionList();
  }

  private getIboBuyOrderList(): void {

    this._req.fetchApiData(this._url.iboBuyListUrl, {}).subscribe(
      (data) => {
        let resSucc = data['data'];
        if (resSucc !== '') {
          this.iboBuyOrder = data['data'];
        } else {
          this.buyOrderMessage = data['error']['errorDescription'];
        }
      }, (error) => {
      });
  }

  private getIboSellOrderList(): void {
    this._req.fetchApiData(this._url.iboSellorderListUrl, {}).subscribe(
      (data) => {
        let resSucc = data['data'];
        if (resSucc !== '') {
          this.iboSellOrder = data['data'];
        } else {
          this.sellOrderMessage = data['error']['errorDescription'];
        }
      }, (error) => {
      });
  }

  private getIboCommissionList(): void {
    this._req.fetchApiData(this._url.iboCommissionListUrl, {}).subscribe(
      (data) => {
        let resSucc = data['data'];
        if (resSucc !== '') {
          this.iboCommissionLog = resSucc.ibocommissionList;
        } else {
          this.commissionLogMessage = data['error']['errorDescription'];
        }
      }, (error) => {
      });
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/ibo/ibo-logs/ibo-logs.component.ts